(() => {
  // work/global-launch-options-2026-11-03/mixed-envelope/src/coilover-cart-ui.mjs
  (function(factory) {
    "use strict";
    const api = factory();
    if (typeof module === "object" && module.exports) module.exports = api;
    else if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", api.start, { once: true });
    else api.start();
  })(function() {
    "use strict";
    const TEXT_KEYS = { "A paid extra is not attached to its kit.": "native_0", "Add to Shopify cart": "native_1", "Add to cart": "native_2", "Added to Shopify cart. Verified build total ": "native_3", "Adding your configured kit\u2026": "native_4", "Adding\u2026": "native_5", "Build total ": "native_6", "Checking Shopify prices\u2026": "native_7", "Choose a quantity from 1 to 20.": "native_8", "Complete the configuration with a current price before adding it.": "native_9", "Continue configuring": "native_10", "Continue to Shopify checkout": "native_11", "Kit quantity": "native_12", "Kits": "native_13", "No coilover test builds are in this Shopify cart.": "native_14", "Open full Shopify cart": "native_15", "Please inspect the Shopify cart before trying again. ": "native_16", "Real Shopify cart for this Unlisted test duplicate only. No payment or order will be submitted.": "native_17", "Real Shopify cart. Taxes and shipping are calculated at checkout. Do not submit payment or an order.": "native_18", "Remove this test build": "native_19", "Shopify cart subtotal ": "native_20", "Shopify cart test": "native_21", "Shopify could not complete this test.": "native_22", "Shopify did not return every selected component.": "native_23", "Shopify prices changed. The build was not added; refresh the market price snapshot.": "native_24", "Shopify pricing or quantity differs from the selected build.": "native_25", "The Shopify total differs from the page quote.": "native_26", "The existing cart changed while adding the test build.": "native_27", "The market changed. Refresh prices before adding this build.": "native_28", "The selected kit could not be verified.": "native_29", "The selected price could not be reconciled.": "native_30", "This paid option is not mapped for the cart test.": "native_31", "This product is outside the cart test.": "native_32", "This test duplicate is not currently available. It must be Unlisted for checkout testing.": "native_33", "Unpublished theme \xB7 Unlisted duplicate \xB7 Real Shopify cart test \xB7 No order submission": "native_34", "View Shopify cart": "native_35", "Your Shopify cart": "native_36", "Your other cart items are preserved and included in the subtotal.": "native_37", "coil-dialog coil-native-dialog": "native_38", "coil-native-panel": "native_39", "coil-native-status": "native_40" };
    let PRODUCT = "", CORE = /* @__PURE__ */ new Set(), CHARGES = {}, BINDING = null;
    let THEME = "", MARKER = "_ceika_coilover_build";
    const label = (value) => String(value || "None").replaceAll("_", " ");
    function plan(state, d, qty, build, labels = {}) {
      const translated = (key, fallback) => labels[key] || fallback;
      if (!d.configurationComplete || !d.pricingCurrent) throw Error("Complete the configuration with a current price before adding it.");
      if (!Number.isSafeInteger(qty) || qty < 1 || qty > 20) throw Error("Choose a quantity from 1 to 20.");
      if (!CORE.has(String(d.core.variantId)) || !/^coil-native-[a-z0-9-]+$/i.test(build)) throw Error("This product is outside the cart test.");
      const properties = {
        [MARKER]: build,
        "_ceika_coilover_role": "kit",
        "_ceika_coilover_test": PRODUCT,
        "Vehicle": BINDING.vehicleName,
        "Setup": translated("setup_" + d.core.setup, label(d.core.setup)) + " / " + d.core.damper.toUpperCase(),
        "Valving": translated("valving_" + d.effectiveValving, label(d.effectiveValving)),
        "Springs front / rear": [d.springRates.frontKgMm, d.springRates.rearKgMm].map((v) => v == null ? "\u2014" : v + " kg/mm").join(" / "),
        "Ride height": translated("height_" + state.height, label(state.height)),
        "Front mounts": translated({ pillowball: "mount_pillowball_title", rubber: "mount_rubber_title", reuse_oem: "mount_reuse_oem_title", no_supplied_mount: "mount_none" }[state.frontMount] || "mount_none", label(state.frontMount)),
        "Rear mounts": translated({ none: "mount_none", no_supplied_mount: "mount_none", reuse_oem: "mount_reuse_oem_title", pillowball: "mount_pillowball_title", rubber: "mount_rubber_title" }[state.rearMount], label(state.rearMount)),
        "Helper springs": translated("helper_" + state.helperScope, label(state.helperScope)),
        "Finish": translated("color_" + state.color, label(state.color)),
        "Reservoir": state.damper === "2m" ? translated(state.reservoirMount === "remote" ? "reservoir_remote" : "reservoir_body", label(state.reservoirMount)) : "\u2014",
        "Production": translated("production_template", "Production: {min}\\u2013{max} working days").replace("{min}", d.manufacturingWorkingDays.min).replace("{max}", d.manufacturingWorkingDays.max).replace(/^[^:：]+[:：]\\s*/, ""),
        "QA": "TEST ONLY \u2014 do not submit an order"
      };
      if (state.damper === "2m" && state.reservoirMount === "remote") properties["Reservoir hose"] = state.hoseLengthCm + " cm";
      const year = typeof document !== 'undefined' && document.querySelector('ceika-reviewed-offers[data-product="'+PRODUCT+'"]')?.dataset.selectedYear;
      if (/^\d{4}$/.test(year || "")) properties["Model year"] = year;
      if (state.notes) properties["Build request"] = state.notes;
      if (!globalThis.CeikaSpringCatalogue) throw Error("Spring catalogue is unavailable.");
      Object.assign(properties, globalThis.CeikaSpringCatalogue.orderProperties(PRODUCT, d.springRates));
      properties._ceika_display = JSON.stringify({ use: state.intendedUse || undefined, setup: properties.Setup, springs: properties["Springs front / rear"], height: properties["Ride height"], helpers: properties["Helper springs"], production: properties.Production });
      const propertyKeys = { "Vehicle": "story_vehicle_label", "Setup": "summary_setup", "Valving": "summary_valving", "Springs front / rear": "summary_springs", "Ride height": "summary_height", "Front mounts": "front_mount_title", "Rear mounts": "rear_mount_title", "Helper springs": "summary_helpers", "Finish": "summary_finish", "Reservoir": "summary_reservoir", "Reservoir hose": "summary_hose", "Build request": "notes_label" };
      for (const [key, translation] of Object.entries(propertyKeys)) {
        const visible = labels[translation];
        if (visible && visible !== key && key in properties) {
          properties[visible] = properties[key];
          delete properties[key];
        }
      }
      const expected = [], items = [];
      for (const component of d.breakdown) {
        const cents = Math.round(component.amountUsd * 100);
        if (component.key !== "core" && cents === 0) continue;
        const key = component.key === "height" ? "height_" + state.height : component.key;
        const id = component.key === "core" ? String(d.core.variantId) : CHARGES[key];
        if (!id || !Number.isSafeInteger(cents) || cents <= 0) throw Error("This paid option is not mapped for the cart test.");
        const props = component.key === "core" ? properties : { [MARKER]: build, "_ceika_coilover_role": "upgrade", "_ceika_coilover_test": PRODUCT, "Upgrade": translated({ custom_pro_valving: "valving_pro", front_mount: "mount_pillowball_title", front_helpers: "helper_front" }[key] || (key.startsWith("height_") ? key : ""), label(key)) };
        items.push({ id, quantity: qty, ...component.key === "core" ? {} : { parent_id: String(d.core.variantId) }, properties: props });
        expected.push({ id, unitCents: cents, quantity: qty });
      }
      const unit = expected.reduce((n, x) => n + x.unitCents, 0);
      if (unit !== Math.round(d.totalUsd * 100)) throw Error("The selected price could not be reconciled.");
      if (BINDING.release?.mode !== "draft_preview") delete properties.QA;
      return { build, items, expected, unitCents: unit, totalCents: unit * qty, currency: d.currency };
    }
    function verifyCart(cart, p) {
      if (cart.currency !== (p.currency || "USD")) throw Error("The market changed. Refresh prices before adding this build.");
      const lines = cart.items.filter((x) => x.properties?.[MARKER] === p.build);
      if (lines.length !== p.expected.length) throw Error("Shopify did not return every selected component.");
      const parent = lines.find((x) => x.properties?._ceika_coilover_role === "kit");
      if (!parent || String(parent.product_id) !== PRODUCT) throw Error("The selected kit could not be verified.");
      let total = 0;
      for (const e of p.expected) {
        const line = lines.find((x) => String(x.variant_id) === e.id);
        if (!line || line.quantity !== e.quantity || line.original_price !== e.unitCents) throw Error("Shopify pricing or quantity differs from the selected build.");
        if (line !== parent && line.parent_relationship?.parent_key !== parent.key) throw Error("A paid extra is not attached to its kit.");
        total += line.final_line_price;
      }
      if (total !== p.totalCents) throw Error("The Shopify total differs from the page quote.");
      return { parent, totalCents: total };
    }
    function start() {
      if (!window.CoiloverCataloguePricingSettled) {
        window.CoiloverPricingReady?.then(() => {
          window.CoiloverCataloguePricingSettled = true;
          start();
        });
        return;
      }
      const root = document.querySelector("[data-coilover-preview]"), model = window.CoiloverModel, pricing = window.CoiloverPricing;
      try {
        BINDING = JSON.parse(document.querySelector("[data-ceika-coilover-commerce]")?.textContent || "null");
      } catch {
        return;
      }
      if (!BINDING || !window.CeikaJointCommerce) return;
      PRODUCT = String(BINDING.productId);
      THEME = String(window.Shopify?.theme?.id || "");
      CORE = new Set(Object.values(BINDING.variantIdsByCore));
      CHARGES = Object.fromEntries(Object.entries(BINDING.chargeBindings).map(([key, value]) => [key, String(value.variantId)]));
      if (!root || root.dataset.catalogueCartReady || !pricing || model?.catalog.productId !== PRODUCT || window.Shopify?.shop !== JSON.parse(document.querySelector("[data-coil-market]").textContent).shopDomain || !(BINDING.purchaseEnabled === false && BINDING.executionAllowed === false || BINDING.purchaseEnabled === true && BINDING.release?.approved === true && BINDING.executionAllowed === true && BINDING.activationPriceReady === true)) return;
      root.dataset.catalogueCartReady = "true";
      let routes = window.Shopify.routes?.root || "/";
      if (!/^\/(?:[a-z0-9]+(?:-[a-z0-9]+)*\/)*$/i.test(routes)) return;
      const endpoint = (name) => routes + name;
      const el = (tag, cls, text) => {
        const n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text) n.textContent = text;
        return n;
      };
      const context = window.CoiloverMarket || {};
      const optionLabels = JSON.parse(root.querySelector("[data-coil-labels]")?.textContent || "{}");
      const designLabels = JSON.parse(document.querySelector('[data-ceika-design-labels]')?.textContent || '{}');
      const tx = (value) => {
        if (context.draftPreview && (value.includes("Unlisted") || value.startsWith("Unpublished theme"))) return context.labels?.catalogue_draft_notice || "Preview only. Checkout is disabled.";
        if (BINDING.release?.mode !== "draft_preview") {
          const mapped = { "Shopify cart test": "catalogue_cart_title", "Your Shopify cart": "catalogue_cart_title", "Kits": "catalogue_quantity", "Kit quantity": "catalogue_quantity", "Remove this test build": "catalogue_remove", "Continue to Shopify checkout": "catalogue_checkout", "No coilover test builds are in this Shopify cart.": "catalogue_empty", "Real Shopify cart. Taxes and shipping are calculated at checkout. Do not submit payment or an order.": "catalogue_cart_notice" };
          if (mapped[value]) return context.labels?.[mapped[value]] || value;
          if (value.includes("Unlisted") || value.startsWith("Unpublished theme")) return "";
        }
        return context.labels?.[TEXT_KEYS[value]] || value;
      };
      const money = (n) => new Intl.NumberFormat(pricing.locale || document.documentElement.lang || "en", { style: "currency", currency: pricing.currency }).format(n / 100);
      const productStatus = document.querySelector("[data-coil-market]") ? JSON.parse(document.querySelector("[data-coil-market]").textContent).draftPreview : false;
      const style = el("style");
      style.textContent = ".coil-native-panel{display:grid;gap:10px;padding:20px 0}.coil-native-panel p{margin:0;line-height:1.5}.coil-native-panel label{display:flex;align-items:center;justify-content:space-between;gap:12px}.coil-native-panel input{width:74px;min-height:44px;padding:8px;border:1px solid #d7dce1;border-radius:8px}.coil-native-action{min-height:46px;padding:12px 18px;border:1px solid #d7dce1;border-radius:8px;background:#fff;color:#20252b;font:600 13px Arial,Helvetica,sans-serif;cursor:pointer;text-decoration:none;display:inline-flex;justify-content:center;align-items:center;margin:4px 6px 4px 0}.coil-native-primary{background:#9e1b32;border-color:#9e1b32;color:#fff}.coil-native-action:disabled{opacity:.45;cursor:not-allowed}.coil-native-dialog article{padding:16px;border:1px solid #d7dce1;border-radius:10px;margin:12px 0}.coil-native-dialog p{line-height:1.5}.coil-native-status{font-size:13px}.coil-native-dialog strong{display:block;margin:14px 0}";
      root.append(style);
      const panel = el("section", "coil-native-panel");
      panel.setAttribute("aria-label", tx("Shopify cart test"));
      panel.append(el("h3", "", tx("Shopify cart test")), el("p", "", tx("Real Shopify cart for this Unlisted test duplicate only. No payment or order will be submitted.")));
      const qtyLabel = el("label", "", tx("Kits")), qty = el("input");
      qty.type = "number";
      qty.min = "1";
      qty.max = "20";
      qty.value = "1";
      qty.setAttribute("aria-label", tx("Kit quantity"));
      qtyLabel.append(qty);
      const add = el("button", "coil-native-action coil-native-primary", tx("Add to cart")), open = el("button", "coil-native-action", tx("View Shopify cart"));
      add.type = open.type = "button";
      add.setAttribute("data-native-add", "");
      const status = el("p", "coil-native-status");
      status.setAttribute("role", "status");
      panel.append(qtyLabel, add, open, status);
      root.querySelector(".coil-order").append(panel);
      const dialog = el("dialog", "coil-dialog coil-native-dialog");
      dialog.setAttribute("aria-label", tx("Your Shopify cart"));
      dialog.dir = /^ar(?:-|$)/i.test(pricing.locale || document.documentElement.lang) ? "rtl" : "ltr";
      const header = el("header", "coil-native-dialog__header"), title = el("h2", "coil-native-dialog__title", tx("Your Shopify cart"));
      const close = el("button", "coil-native-action coil-native-dialog__close", "×");
      close.type = "button";
      close.setAttribute("aria-label", tx("Continue configuring"));
      close.addEventListener("click", () => dialog.close());
      header.append(title, close);
      const body = el("div", "coil-native-dialog__body"), list = el("div", "coil-native-dialog__items");
      const suggestions = el("section", "ceika-cart-modal__suggestions");
      const footer = el("footer", "coil-native-dialog__footer ceika-cart-modal__footer"), subtotal = el("strong", "coil-native-dialog__subtotal"), notice = el("p", "coil-native-dialog__notice", document.querySelector('[data-ceika-cart-policy]')?.dataset.marketNote || tx("Real Shopify cart. Taxes and shipping are calculated at checkout. Do not submit payment or an order."));
      const cartLink = el("a", "coil-native-action", tx("Open full Shopify cart"));
      cartLink.href = endpoint("cart") + "?preview_theme_id=" + THEME;
      cartLink.target = window.Shopify.designMode ? "_blank" : "_self";
      cartLink.rel = "noopener";
      const checkout = el("a", "coil-native-action coil-native-primary", tx("Continue to Shopify checkout"));
      checkout.setAttribute('aria-label', tx("Continue to Shopify checkout"));
      checkout.href = document.querySelector('[data-ceika-cart-policy]')?.dataset.termsRequired === 'true' ? cartLink.href : endpoint("checkout");
      checkout.target = window.Shopify.designMode ? "_blank" : "_self";
      checkout.rel = "noopener";
      const actions = el("div", "coil-native-dialog__actions");
      actions.append(cartLink, checkout);
      const marketDetails = el("details","coil-native-dialog__market");
      marketDetails.append(el("summary","",document.querySelector('[data-ceika-cart-policy]')?.dataset.shippingLabel || "Shipping"),notice);
      footer.append(subtotal, marketDetails, actions);
      body.append(list, suggestions);
      dialog.append(header, body, footer);
      root.append(dialog);
      const banner = root.querySelector(".coil-test");
      if (banner) banner.textContent = tx("Unpublished theme \xB7 Unlisted duplicate \xB7 Real Shopify cart test \xB7 No order submission");
      let current = null, busy = false, lastCart = null, editing = new URLSearchParams(location.search).get("ceika_coil_edit"), editReady = !editing;
      const api = async (path, data) => {
        const response = await fetch(endpoint(path), { method: data ? "POST" : "GET", credentials: "same-origin", cache: "no-store", headers: { Accept: "application/json", ...data ? { "Content-Type": "application/json" } : {} }, ...data ? { body: JSON.stringify(data) } : {} });
        const body = await response.json();
        if (!response.ok) throw Error(body.description || body.message || tx("Shopify could not complete this test."));
        return body;
      };
      const setBusy = (value) => {
        busy = value;
        add.disabled = productStatus || busy || !editReady || BINDING.executionAllowed !== true || BINDING.purchaseEnabled !== true || BINDING.activationPriceReady !== true || !current || !model.derive(current, pricing).configurationComplete || !model.derive(current, pricing).pricingCurrent;
        reviewAdd.disabled = add.disabled;
        add.textContent = value ? tx("Adding\u2026") : editing ? context.labels?.save_edited_build || "Save configuration" : tx("Add to cart");
      };
      const ownParents = (cart) => cart.items.filter((x) => String(x.product_id) === PRODUCT && x.properties?._ceika_coilover_test === PRODUCT && x.properties?._ceika_coilover_role === "kit" && /^coil-native-/.test(x.properties?.[MARKER] || ""));
      const editLabel = document.querySelector('[data-ceika-cart-policy]')?.dataset.editLabel || "Review configuration & upgrades";
      const safeEditHref = (parent, cart) => {
        const build = parent.properties?._ceika_build;
        if (window.CeikaCartRecommendations?.exactParent(cart, build, PRODUCT)?.key !== parent.key) return "";
        try {
          const url = new URL(parent.url, location.origin);
          const path = /^\/(?:[a-z0-9]+(?:-[a-z0-9]+)*\/)?products\/[a-z0-9][a-z0-9_-]*\/?$/i;
          if (url.origin !== location.origin || url.username || url.password || !path.test(url.pathname) ||
              url.pathname.replace(/\/$/,"") !== location.pathname.replace(/\/$/,"")) return "";
          url.searchParams.set("ceika_coil_edit",build);
          if (["unpublished","development"].includes(window.Shopify?.theme?.role)) url.searchParams.set("preview_theme_id",THEME);
          return url.href;
        } catch { return ""; }
      };
      const safeImageURL = (value) => {
        if (typeof value !== 'string' || !value.trim()) return '';
        try {
          const url = new URL(value, location.href);
          return url.protocol === "https:" || url.origin === location.origin ? url.href : "";
        } catch { return ""; }
      };
      const showCart = (cart) => {
        lastCart = cart;
        list.replaceChildren();
        const parents = ownParents(cart);
        for (const parent of parents) {
          let display;
          try {
            display = JSON.parse(parent.properties._ceika_display);
          } catch (error) {
            display = { setup: parent.properties.Setup, springs: parent.properties["Springs front / rear"], height: parent.properties["Ride height"], helpers: parent.properties["Helper springs"], production: parent.properties.Production };
          }
          const card = el("article", "coil-native-dialog__build");
          const heading = el("div", "coil-native-dialog__build-heading");
          const imageURL = safeImageURL(parent.image);
          if (imageURL) {
            const image = el("img", "coil-native-dialog__build-image");
            image.src = imageURL;
            image.alt = parent.product_title || "";
            image.loading = "lazy";
            heading.append(image);
          }
          const identity = el("div", "coil-native-dialog__identity");
          identity.append(el("h3", "", parent.product_title), el("p", "", display.setup));
          heading.append(identity);
          card.append(heading);
          const lines = cart.items.filter((x) => x.properties?.[MARKER] === parent.properties[MARKER]);
          const details = el("details", "coil-native-dialog__details"), summary = el("summary", "", (designLabels.price_details || optionLabels.summary_setup || tx("Your Shopify cart")).replace(/&amp;/g, '&'));
          const rows = el("div", "coil-native-dialog__rows");
          const propertyLabels = [["Vehicle", "story_vehicle_label"], ["Setup", "summary_setup"], ["Valving", "summary_valving"], ["Springs front / rear", "summary_springs"], ["Ride height", "summary_height"], ["Front mounts", "front_mount_title"], ["Rear mounts", "rear_mount_title"], ["Helper springs", "summary_helpers"], ["Finish", "summary_finish"], ["Reservoir", "summary_reservoir"], ["Reservoir hose", "summary_hose"], ["Build request", "notes_label"]];
          for (const [canonical, translationKey] of propertyLabels) {
            const visibleKey = optionLabels[translationKey] && parent.properties?.[optionLabels[translationKey]] !== undefined ? optionLabels[translationKey] : canonical;
            const value = parent.properties?.[visibleKey];
            if (!value) continue;
            const row = el("p", "coil-native-dialog__row");
            row.append(el("span", "", optionLabels[translationKey] || canonical), el("strong", "", value));
            rows.append(row);
          }
          for (const line of lines) {
            const row = el("p", "coil-native-dialog__row coil-native-dialog__price-row");
            const part = line === parent ? optionLabels.setup_label || optionLabels.summary_setup || tx("Your Shopify cart") : line.properties?.Upgrade || optionLabels.summary_setup || tx("Your Shopify cart");
            row.append(el("span", "", part + " · " + line.quantity), el("strong", "", money(line.final_line_price)));
            rows.append(row);
          }
          details.append(summary, rows);
          card.append(details);
          const total = lines.reduce((n, x) => n + x.final_line_price, 0);
          const buildTotal = el("div", "coil-native-dialog__build-total");
          buildTotal.append(el("span", "", tx("Kits") + " · " + parent.quantity), el("strong", "", money(total)));
          card.append(buildTotal);
          const editHref = safeEditHref(parent, cart);
          if (editHref) {
            const edit = el("a", "coil-native-action coil-native-dialog__edit", editLabel);
            edit.href = editHref;
            card.append(edit);
          }
          const remove = el("button", "coil-native-action coil-native-dialog__remove", tx("Remove this test build"));
          remove.type = "button";
          remove.addEventListener("click", async () => {
            if (busy) return;
            try {
              setBusy(true);
              await window.CeikaJointCommerce.withCartLock(async () => {
                await api("cart/change.js", { id: parent.key, quantity: 0 });
                showCart(await api("cart.js"));
              });
            } catch (e) {
              status.textContent = tx(e.message);
            } finally {
              setBusy(false);
            }
          });
          card.append(remove);
          list.append(card);
        }
        const buildMarkers = new Set(parents.map((parent) => parent.properties[MARKER]));
        const otherItems = cart.items.filter((item) => !buildMarkers.has(item.properties?.[MARKER]));
        const otherParents = otherItems.filter(item => !item.parent_relationship && item.properties?._ceika_role !== 'upgrade' && item.properties?._ceika_coilover_role !== 'upgrade' && item.product_type !== 'OPTIONS_HIDDEN_PRODUCT');
        for (const item of otherParents) {
          const card = el('article', 'coil-native-dialog__other-item');
          const imageURL = safeImageURL(item.image);
          if (imageURL) {
            const image = el('img', 'coil-native-dialog__other-image');
            image.src = imageURL;
            image.alt = item.product_title || '';
            image.loading = 'lazy';
            card.append(image);
          }
          card.append(el('p', '', item.product_title), el('p', 'coil-native-dialog__other-note', tx('Kits') + ' · ' + item.quantity));
          list.append(card);
        }
        if (!cart.item_count) list.append(el("p", "", tx("No coilover test builds are in this Shopify cart.")));
        if (otherItems.length) list.append(el("p", "coil-native-dialog__other-note", tx("Your other cart items are preserved and included in the subtotal.")));
        subtotal.textContent = tx("Shopify cart subtotal ") + money(cart.total_price);
        checkout.hidden = !cart.item_count;
        if (!dialog.open) dialog.showModal();
        dialog.dispatchEvent(new CustomEvent("ceika:cart-rendered", { bubbles: true }));
      };
      const rollback = async (build) => window.CeikaJointCommerce.withCartLock(async () => {
        const cart = await api("cart.js");
        const parent = ownParents(cart).find((x) => x.properties[MARKER] === build);
        if (parent) await api("cart/change.js", { id: parent.key, quantity: 0 });
      });
      const save = async () => {
        if (productStatus || BINDING.executionAllowed !== true || BINDING.purchaseEnabled !== true || BINDING.activationPriceReady !== true || busy || !current || !editReady) return;
        const state = { ...current }, build = "coil-native-" + crypto.randomUUID();
        let posted = false;
        try {
          setBusy(true);
          status.textContent = tx("Checking Shopify prices\u2026");
          const derived = model.derive(state, pricing), p = plan(state, derived, Number(qty.value), build, optionLabels);
          const marketPrices = Object.fromEntries(p.expected.map((x) => [x.id, { price: x.unitCents, currency: derived.currency }]));
          status.textContent = tx("Adding your configured kit\u2026");
          const args = { binding: BINDING, state, derived, quantity: Number(qty.value), buildId: build, marketPrices, displayProperties: p.items[0].properties, api };
          const result = await window.CeikaJointCommerce.withCartLock(() => editing ? window.CeikaJointCommerce.replaceCoilover(args, editing) : window.CeikaJointCommerce.addCoilover(args));
          editing = null;
          const cleanURL = new URL(location.href);
          cleanURL.searchParams.delete("ceika_coil_edit");
          history.replaceState(null, "", cleanURL);
          const cart = result.cart;
          status.textContent = tx("Added to Shopify cart. Verified build total ") + money(result.totalMinor) + ".";
          root.querySelector(".coil-dialog[open]")?.close();
          showCart(cart);
        } catch (e) {
          if (posted) {
            try {
              await rollback(build);
            } catch (cleanupError) {
              status.textContent = tx("Please inspect the Shopify cart before trying again. ") + cleanupError.message;
              return;
            }
          }
          status.textContent = tx(e.message);
        } finally {
          setBusy(false);
        }
      };
      root.querySelector("[data-cart-add]")?.setAttribute("hidden", "");
      root.querySelector("[data-cart-unavailable]")?.setAttribute("hidden", "");
      const reviewAdd = el("button", "coil-native-action coil-native-primary", tx("Add to Shopify cart"));
      reviewAdd.type = "button";
      reviewAdd.addEventListener("click", save);
      root.querySelector(".coil-dialog").append(reviewAdd);
      add.addEventListener("click", save);
      open.addEventListener("click", async () => {
        try {
          showCart(await api("cart.js"));
        } catch (e) {
          status.textContent = tx(e.message);
        }
      });
      root.addEventListener("coilover:selection", (e) => {
        current = { ...e.detail.state };
        setBusy(busy);
      });
      root.dispatchEvent(new CustomEvent("coilover:request-selection"));
      setBusy(false);
      if (editing) api("cart.js").then((cart) => {
        const parent = window.CeikaCartRecommendations?.exactParent(cart,editing,PRODUCT);
        if (!parent) throw Error(context.labels?.catalogue_empty || tx("The selected kit could not be verified."));
        const saved = window.CeikaJointCommerce.restoreCoilover(cart, BINDING, editing);
        const original = JSON.parse(parent.properties._ceika_display || "{}");
        if (["daily","rally","spirited","track"].includes(original.use)) saved.state.intendedUse = original.use;
        qty.value = String(saved.quantity);
        root.dispatchEvent(new CustomEvent("coilover:edit-build", { detail: { selection: saved.state } }));
        editReady = true;
        status.textContent = context.labels?.editing_saved_build || "Editing your saved configuration. Save to update this build in the cart.";
        setBusy(false);
      }).catch((error) => {
        status.textContent = error.message;
        setBusy(false);
      }).finally(() => {
        root.dispatchEvent(new CustomEvent("coilover:edit-settled"));
      });
    }
    return { plan, verifyCart, start };
  });
})();

